import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
  navItems: Array<{
    id: string;
    label: string;
    icon: React.ElementType;
  }>;
  activeItem: string;
  setActiveItem: (id: string) => void;
}
export const MobileNav: React.FC<MobileNavProps> = ({
  isOpen,
  onClose,
  navItems,
  activeItem,
  setActiveItem
}) => {
  return <AnimatePresence data-id="element-579">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} className="fixed inset-0 bg-black/30 backdrop-blur-sm md:hidden z-40" data-id="element-580" />
          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 30,
        stiffness: 300
      }} className="fixed bottom-0 inset-x-0 bg-[#FFFFFF] rounded-t-sm shadow-2xl md:hidden z-50" data-id="element-581">
            <div className="relative p-6" data-id="element-582">
              <div className="absolute left-1/2 -translate-x-1/2 -top-3 w-12 h-1.5 bg-[#E5E5E5] rounded-full" data-id="element-583" />
              <button onClick={onClose} className="absolute right-5 top-5 p-2 hover:bg-[#F9FAFB] rounded-sm transition-colors" data-id="element-584">
                <XIcon className="h-5 w-5 text-[#AAAAAA]" data-id="element-585" />
              </button>

              <nav className="mt-8 space-y-2" data-id="element-586">
                {navItems.map(item => {
              const Icon = item.icon;
              return <button key={item.id} onClick={() => {
                setActiveItem(item.id);
                onClose();
              }} className={`flex items-center w-full px-4 py-3.5 rounded-sm text-sm font-medium transition-all ${activeItem === item.id ? 'bg-[#C00000]/10 text-[#C00000]' : 'text-[#AAAAAA] hover:bg-[#F9FAFB]'}`} data-id="element-587">
                      <Icon className="h-5 w-5 mr-3" data-id="element-588" />
                      {item.label}
                    </button>;
            })}
              </nav>

              <div className="mt-8 space-y-3 px-1" data-id="element-589">
                <button onClick={() => {
              console.log('Exporting report as PDF...');
              onClose();
            }} className="flex items-center justify-center w-full py-3 space-x-2 bg-[#FFFFFF] border border-[#E5E5E5] text-[#171717] font-medium hover:bg-[#F9FAFB] transition-colors" data-id="element-590">
                  <span data-id="element-591">Export report</span>
                </button>
                <a href="https://brandpulse-analytics.com/create" target="_blank" rel="noopener noreferrer" className="relative group block" onClick={onClose} data-id="element-592">
                  <span className="flex items-center justify-center w-full py-3 bg-[#0D5C91] text-white font-medium hover:bg-[#0D5C91]/90 transition-colors relative z-10" data-id="element-593">
                    Create new test
                    <span className="ml-2 text-white transition-transform group-hover:translate-x-0.5" data-id="element-594">
                      ›
                    </span>
                  </span>
                </a>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
};